import Vue from 'vue'
import Router from 'vue-router'
import fxView from '@/components/fxView'
import store from '../store/store.js'
const login = () => import('@/components/fxView/user/login')
const register = () => import('@/components/fxView/user/register')
const index = () => import('@/components/fxView/home/index')

const commissionwithdrawals = () => import('@/components/fxView/ibtools/commission-withdrawals')
const briefreport = () => import('@/components/fxView/ibtools/brief-report')
const referrallinks = () => import('@/components/fxView/ibtools/referral-links')

const leadslisting = () => import('@/components/fxView/client-details/leads-listing')
const tradinglisting = () => import('@/components/fxView/client-details/trading-listing')
const depositslisting = () => import('@/components/fxView/client-details/deposits-listing')
const withdrawalslisting = () => import('@/components/fxView/client-details/withdrawals-listing')
const subIblisting = () => import('@/components/fxView/client-details/user-subIb-list')
const commissionListing = () => import('@/components/fxView/client-details/commission-listing')
const commissionRequest = () => import('@/components/fxView/client-details/commission-request')
const request_verify = () => import('@/components/fxView/client-details/request_verify')
const profile = () => import('@/components/fxView/user/profile')
const updateProfile = () => import('@/components/fxView/user/update_profile')

const changepassword = () => import('@/components/fxView/user/changepassword')
const forgotpassword = () => import('@/components/fxView/user/forgetPassword')

const logs_listing = () => import('@/components/fxView/logs/logs_listing')

const resetPassword = () => import('@/components/fxView/user/resetPassword')
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'fxView.login', component: login },
	{ path: '/register', name: 'fxView.register', component: register },
	{ path: '/forgotpassword', name: 'forgotpassword', component: forgotpassword },
	{ path: '/forgot/password', name: 'resetPassword', component: resetPassword },
    { 
	path: '/', 
	component: fxView, 
	children:[
			{ path: '/index', name: 'fxView.index', component: index },
			{ 
				path: '/commission-withdrawals', 
				name: 'fxView.commissionwithdrawals', 
				component: commissionwithdrawals 
			},
			{ path: '/brief-report', name: 'fxView.brief-report', component: briefreport },
			{ path: '/referral-links', name: 'fxView.referrallinks', component: referrallinks },
			{ path: '/leads-listing', name: 'fxView.leadslisting', component: leadslisting },
			{ path: '/trading-listing', name: 'fxView.tradinglisting', component: tradinglisting },
			{ path: '/deposits-listing', name: 'fxView.depositslisting', component: depositslisting },
			{ path: '/withdrawals-listing', name: 'fxView.withdrawalslisting', component: withdrawalslisting },
			{ path: '/profile', name: 'fxView.profile', component: profile },
			{ path: '/update-profile', name: 'fxView.updateProfile', component: updateProfile },
			{ path: '/changepassword', name: 'fxView.changepassword', component: changepassword },
			{ path: '/logs-listing', name: 'fxView.logs_listing', component: logs_listing },
			{ path: '/sub-ib-listing', name: 'fxView.sub_ib_listing', component: subIblisting },
			{ path: '/commission-listing', name: 'fxView.commission_listing', component: commissionListing },
			{ path: '/commission-request', name: 'fxView.commission_request', component: commissionRequest },
			{ path: '/commission-verify', name: 'fxView.request_verify', component: request_verify }
		] 
	}
	

  ]
})

router.beforeEach((to, from, next) => {
	const userStateVariable = store.state.user
	if (to.name !== 'fxView.login' && to.name !== 'fxView.register' && to.name !== 'forgotpassword' && to.name !== 'resetPassword' && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) next({ name: 'fxView.login' })
	else next()
  })

export default router


// WEBPACK FOOTER //
// ./src/router/index.js